import { FullProductType } from "@domain/product/product";
import { AlarmDeviceConfiguration } from "@domain/project/configurations/alarm-device-configuration";
import { FlameDetectorConfiguration } from "@domain/project/configurations/flame-detector-configuration";
import { GasWarningCenterConfiguration } from "@domain/project/configurations/gas-warning-center-configuration";
import { PlasticSignConfiguration } from "@domain/project/configurations/plastic-sign-configuration";
import { SignalElementConfiguration } from "@domain/project/configurations/signal-element-configuration";
import { TransmitterConfiguration } from "@domain/project/configurations/transmitter-configuration";
import { ProductData } from "@domain/project/product-data/product-data";

export class ConfigProductMap {
  _placedProductsCount: number = 0;
  _additionalProductsCount: number = 0;
  _config:
    | AlarmDeviceConfiguration
    | GasWarningCenterConfiguration
    | PlasticSignConfiguration
    | SignalElementConfiguration
    | TransmitterConfiguration
    | FlameDetectorConfiguration;
  _data: ProductData[];
  _attachmentInstructions?: ProductData[];

  constructor(
    config:
      | AlarmDeviceConfiguration
      | GasWarningCenterConfiguration
      | PlasticSignConfiguration
      | SignalElementConfiguration
      | TransmitterConfiguration
      | FlameDetectorConfiguration,
    data: ProductData[],
    count: number,
  ) {
    this._config = config;
    this._data = data;
    this._placedProductsCount = count;
    this._additionalProductsCount = config.additionalProductListQuantity;
    this.moveAttachmentInstructions();
  }

  get config() {
    return this._config;
  }

  get data() {
    return this._data;
  }

  get attachmentInstructions() {
    return this._attachmentInstructions;
  }

  get placedProductsCount() {
    return this._placedProductsCount;
  }

  get additionalProductsCount() {
    return this._additionalProductsCount;
  }

  get totalProductsCount() {
    return this._placedProductsCount + this._additionalProductsCount;
  }

  private moveAttachmentInstructions() {
    this.filterForAttachmentInstructions();
    this.removeAttachmentInstructionsFromData();
  }

  private filterForAttachmentInstructions() {
    const instructions = this._data.filter((data: ProductData) => data.fullType === FullProductType.ATTACHMENT_INSTRUCTIONS);

    const uniqueById = new Map<string, ProductData>();

    for (const item of instructions) {
      const existing = uniqueById.get(item.id!);

      if (!existing) {
        uniqueById.set(item.id!, item);
      } else {
        const aSuffix = this.getSuffixLetter(item.positionId!);
        const bSuffix = this.getSuffixLetter(existing.positionId!);

        if (aSuffix.localeCompare(bSuffix) < 0) {
          uniqueById.set(item.id!, item);
        }
      }
    }
    this._attachmentInstructions = Array.from(uniqueById.values());
  }

  private getSuffixLetter(positionId: string): string {
    const parts = positionId.split(".");
    return parts[1]?.toLowerCase() ?? ""; // fallback: empty string if no suffix
  }

  private removeAttachmentInstructionsFromData() {
    this._data = this._data.filter((data: ProductData) => data.fullType !== FullProductType.ATTACHMENT_INSTRUCTIONS);
  }
}
